DatabaseDeleteModalController.$inject= ['DatabaseService'];
export default function DatabaseDeleteModalController(DatabaseService) {
    var ctrl = this;

    ctrl.isSuccess = false;
    ctrl.isProcess = false;
    ctrl.isError = false;

    ctrl.$onChanges = function(changes) {
        if (changes) {
            ctrl.database = changes.resolve.currentValue.params.database;
        }
    };

    ctrl.remove = function() {
        var qs = {
            id: ctrl.database
        };
        ctrl.isProcess = true;
        DatabaseService.remove(qs).$promise.then(function(response) {
            if (response.success) {
                ctrl.response = response;
                ctrl.isSuccess = true;
            } else {
                ctrl.isError = true;
            }
            ctrl.isProcess = false;
        }, function(error) {
            console.log(error);
            ctrl.isError = error;
            ctrl.isProcess = false;
        });
    };

    ctrl.ok = function() {
        ctrl.modalInstance.close(ctrl.response);
    };

    ctrl.cancel = function() {
        ctrl.modalInstance.dismiss("cancel");
    };

}
